import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { removeNotificaton, selectNotifications, selectPreviousLength } from '../../store/slices/notifications.slice';
import { dispatch } from '../../store';
import { NotificationEventType } from '@cyberlabrs/types';
import { AppConfig } from '../../config/AppConfig';

const useWaitForNotification = (type: NotificationEventType, onArrival: (body: any) => void) => {
    const notifications = useSelector(selectNotifications);
    const notificationsPreviousLenght = useSelector(selectPreviousLength);

    useEffect(() => {
        if (AppConfig.isWebSocketEnabled && notifications.length > notificationsPreviousLenght)
            for (let notif of notifications) {
                if (notif.type === type) {
                    onArrival(notif.body);
                    dispatch(removeNotificaton(notif.eventId));
                    break;
                }
            }
    }, [notifications.length, notificationsPreviousLenght]);
};

export default useWaitForNotification;
